import request from '@/utils/request'
import URL from './urlTranslator'

// 获取费用方案列表
export function getCostPlanList(params) {
  return request({
    url: URL.mdm.costPlan.costPlanInfo,
    method: 'get',
    params
  })
}

// 获取费用方案列表
export function getCostPlanDetail(uuid) {
  return request({
    url: URL.mdm.costPlan.costPlanDetail + '?uuid=' + encodeURIComponent(uuid),
    method: 'get'
  })
}

// 删除费用方案
export function batchDelCostPlan(data) {
  return request({
    url: URL.mdm.costPlan.costPlanInfo,
    method: 'delete',
    data
  })
}

// 删除费用方案详情
export function batchDelCostPlanDetail(data) {
  return request({
    url: URL.mdm.costPlan.costPlanDetail,
    method: 'delete',
    data
  })
}

// 新增费用方案
export function addCostPlan(data) {
  return request({
    url: URL.mdm.costPlan.costPlanInfo,
    method: 'post',
    data
  })
}

// 更新费用方案
export function updateCostPlan(data) {
  return request({
    url: URL.mdm.costPlan.costPlanInfo,
    method: 'put',
    data
  })
}

// 更新费用方案
export function updateApprovedState(data) {
  return request({
    url: URL.mdm.costPlan.updateApprovedState,
    method: 'put',
    data
  })
}

// 更新费用方案
export function batchUpdateStateFunc(data, params) {
  return request({
    url: URL.mdm.costPlan.batchUpdateStateUrl,
    method: 'post',
    data: data,
    params: params
  })
}

// 匹配费用方案
export function chargeSchemeSelector(data) {
  return request({
    url: URL.mdm.costPlan.chargeSchemeSelector,
    method: 'post',
    data
  })
}

// 仅用于刷数据
export function refreshChargeSchemeFunc(id) {
  return request({
    url: URL.mdm.costPlan.refreshChargeSchemeUrl + '?officeId=' + id,
    method: 'get'
  })
}

// 加载费用方案
export function queryChargeScheme(uuid) {
  return request({
    url: URL.mdm.costPlan.queryChargeScheme + '?uuid=' + encodeURIComponent(uuid),
    method: 'get'
  })
}
